// configuration
var cuPrivacyNotice = {
  expiration: 30, /* (production) 30 days, (dev) 0.000231481 for 20 seconds */
  full_width: false,
  close_button_override: false, /* false OR custom message, ex.: 'Got it!' */
  scroll_auto_dismiss: false
};

var message = 'This website uses cookies as well as similar tools and technologies to understand visitors\' experiences. By continuing to use this website, you consent to Columbia University\'s usage of cookies and similar technologies, in accordance with the <a href="https://cuit.columbia.edu/content/columbia-university-website-cookie-notice">Columbia University Website Cookie Notice</a>.';

var icon = (!cuPrivacyNotice.close_button_override) ? '<div id="cu-privacy-notice-icon"></div>' : '<div id="cu-privacy-notice-button">' + cuPrivacyNotice.close_button_override + '</div>';

function cuPrivacyNoticeGetCookie() {
  var name = "cuPrivacyNotice";
  var output = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return output ? output.pop() : '';
}

function cuPrivacyNoticeSetCookie(days) {
  var d = new Date();
  d.setTime(d.getTime() + (days*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = "cuPrivacyNotice=1;" + expires + ";path=/";
}

function cuPrivacyNoticeClose() {
  var child = document.getElementById("cu-privacy-notice");
  document.getElementById("cu-privacy-notice").setAttribute("class", "dismissed");
  setTimeout(function() {
    child.parentNode.removeChild(child);
  }, 400);

  cuPrivacyNoticeSetCookie(cuPrivacyNotice.expiration);
}

function cuPrivacyNoticeScroll(e) {
  if (window.scrollY > 20) {
    cuPrivacyNoticeClose();
    if (window.removeEventListener) {
      window.removeEventListener('scroll', cuPrivacyNoticeScroll, false);
    }
    else if (window.detachEvent) {
      window.detachEvent('onscroll', cuPrivacyNoticeScroll);
    }
  }
}

var cookie = cuPrivacyNoticeGetCookie();

if (!cookie) {
  var classes = [];
  if (cuPrivacyNotice.full_width) {
    classes.push('full-width');
  }
  if (cuPrivacyNotice.close_button_override) {
    classes.push('with-message');
  }

  document.writeln('<div id="cu-privacy-notice"' + ((classes) ? ' class="' + classes.join(" ") + '"' : '') + '><div id="cu-privacy-notice-wrapper"><div id="cu-privacy-notice-text">' + message + '</div><button class="cu-privacy-notice-close" onClick="cuPrivacyNoticeClose()" aria-describedby="cu-privacy-notice-text" tabindex="10"><span class="sr-only">Close Cookie Notice</span><div id="cu-privacy-notice-button">I AGREE</div></div></button></div>');

  if (cuPrivacyNotice.scroll_auto_dismiss) {
    setTimeout(function() {
      if (window.addEventListener) {
        window.addEventListener('scroll', cuPrivacyNoticeScroll, false);
      }
      else if (window.attachEvent) {
        window.attachEvent('onscroll', cuPrivacyNoticeScroll);
      }
    }, 1000);
  }
}
